// api key
export const key = "abc12341";
export const BASE_URL = import.meta.env.VITE_CLEVERREACH_API_BASE_URL;
//urls for office selection
export const COMPANY_URL = BASE_URL + "/jmapi/v1/companies";
export const PROJECTS_URL = BASE_URL + "/jmapi/v1/projects";
export const OFFICES_URL = BASE_URL + "/jmapi/v1/offices";

//url for adress_id
export const ADRESS_ID_URL = BASE_URL + "/jmapi/v1/adress_with_data";

//url for address with given id
export const ADRESS_WITH_ID_URL = BASE_URL + "/jmapi/v1/adress_with_id";

//urls for adresses
export const ADRESS_URL = BASE_URL + "/jmapi/v1/adresses";

//url for cr-export
export const CREXPORT_URL = BASE_URL + "/jmapi/v1/cr-export";

// url for cr-import
export const CRIMPORT_URL = BASE_URL + "/jmapi/v1/cr-import";

// url for the current user's own import quota
export const USER_QUOTA_URL = BASE_URL + "/jmapi/v1/user-quota";

// url for geocoding
export const GEOCODING_URL = BASE_URL + "/jmapi/v1/geocoding";

// url for geopackage files
export const GEOPACKAGE_URL = BASE_URL + "/jmapi/v1/geopackage";

// url for geopackage layers
export const GEOPACKAGE_LAYERS_URL = BASE_URL + "/jmapi/v1/geopackage/layers";

// url for geopackage features
export const GEOPACKAGE_FEATURES_URL =
  BASE_URL + "/jmapi/v1/geopackage/features";

// url for import status
export const IMPORT_STATUS_URL = BASE_URL + "/jmapi/v1/status";

// url for metrics
export const METRICS_URL = BASE_URL + "/jmapi/v1/metrics?";

// url for mobscore
export const MOBSCORE_URL = BASE_URL + "/jmapi/v1/mobscore";

// url for adress_id from office
export const OFFICE_ADRESS_ID_URL = BASE_URL + "/jmapi/v1/offices/id";

// url for parameters
export const PARAMETERS_URL = BASE_URL + "/jmapi/v1/parameters";

// url for parameters for specific transport type
export const PARAMETERS_BY_TRANSPORT_URL =
  BASE_URL + "/jmapi/v1/parameters/transport";

// url for default parameters
export const DEFAULT_PARAMETERS_URL = BASE_URL + "/jmapi/v1/parameters/default";

// urls for office-specific parameters
export const OFFICE_PARAMETERS_URL = BASE_URL + "/jmapi/v1/office-parameters";
export const OFFICE_PARAMETERS_INITIALIZE_URL =
  BASE_URL + "/jmapi/v1/office-parameters/office";
export const OFFICE_PARAMETERS_DELETE_URL =
  BASE_URL + "/jmapi/v1/office-parameters/office";

// urls for congestion surcharges per postal code (Stauaufschläge)
export const PLZ_SURCHARGE_URL = BASE_URL + "/jmapi/v1/plz-surcharges/office";
export const PLZ_SURCHARGE_TRANSPORTS_URL =
  BASE_URL + "/jmapi/v1/plz-surcharges/transports";

// url for paths with office id
export const PATHS_OFFICE_URL = BASE_URL + "/jmapi/v1/paths/office";

// url for paths without geo
export const PATHS_GEO_URL = BASE_URL + "/jmapi/v1/paths/geo";

// url for paths
export const PATHS_URL = BASE_URL + "/jmapi/v1/paths";

// url for file
export const UPLOAD_URL = BASE_URL + "/jmapi/v1/upload";

// url for csv download
export const DOWNLOAD_CSV_URL = BASE_URL + "/jmapi/v1/download_csv";

// url for excel download
export const DOWNLOAD_EXCEL_URL = BASE_URL + "/jmapi/v1/download_excel";

// url for route errors
export const ROUTE_ERRORS_URL = BASE_URL + "/jmapi/v1/routes/errors";

// url for project_user_relation
export const PROJECT_USER_REL_URL = BASE_URL + "/jmapi/v1/user/usersOfProject";

// url for user_company
export const USER_COMPANY_URL = BASE_URL + "/jmapi/v1/user_company";

// url for zip codes
export const ZIPCODES_URL = BASE_URL + "/jmapi/v1/zipcodes";

// url for transport leg count
export const TRANSPORT_LEG_COUNT_URL =
  BASE_URL + "/jmapi/v1/transport-chain/leg-count";
